import { Breadcrumb, BreadcrumbProps } from "antd";
import React from "react";
import SearchBarWidget from "./SearchBarWidget";

interface HeadlineFullProps {
  bannerImage: string;
  mobileImage: string;
  showSearch?: boolean;
  title?: string;
  children?: React.ReactNode;
  breadcrumbs: BreadcrumbProps['items'];
}

const HeadlineFull = (props: HeadlineFullProps) => {
  const { mobileImage, bannerImage, title, children, breadcrumbs, showSearch = true } = props;
  return (
    <>
      {showSearch && <SearchBarWidget/>}
      <div className="headline">
        <div className="headline_banner_full" style={{
          "--desktop-bg": `url(${bannerImage})`,
          "--mobile-bg": `url(${mobileImage})`,
        } as React.CSSProperties}></div>
        <div className="headline_header"> 
          { title ? <h1> {title} </h1> : children}
          <Breadcrumb items={breadcrumbs} separator=">"/>
        </div>
      </div>
    </>
  )
}

export default HeadlineFull;